import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {ValidatorService} from '../recursos/servicios/validator.service';
import {ReceiverValidatorService} from '../recursos/servicios/ReceiverValidatorService';
import {Emisor} from '../recursos/modelo/emisor';
import {UtilConfig} from '../../../../../autenticacion/servicios/UtilConfig';
import {WebServices} from '../../../../recursos/modelo/consumerModel/web-services.enum';
import {ConsumerService} from '../../../../recursos/servicio/consumer.service';
import {Usuario} from '../../usuario/recursos/modelo/usuario';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {GreCarrier} from '../recursos/modelo/gre-carrier';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';

declare const $: any;
declare var swal: any;

interface FileReaderEventTarget extends EventTarget {
    result: string;
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;

    getMessage(): string;
}

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'cmp-conf-gre-carrier',
    templateUrl: './view/cmp-conf-gre-carrier.component.html',
    styleUrls: ['./css/cmp-conf-gre-carrier.component.scss'],
    providers: [
        {provide: ValidatorService, useClass: ReceiverValidatorService}
    ],
})
export class CmpGRECarrierComponent implements OnInit, AfterViewInit {


    @Input() emisor: Emisor;

    @Output() pointListChange = new EventEmitter<GreCarrier[]>();
    RUC = '6';
    DND = '0';
    DNI = '1';
    CARNET_EXTRAJERIA = '4';
    PASAPORTE = '7';

    mostrar = false;

    archivoExcel = '';
    tamanoIdDocNumber = '8';

    rutaFormato = '';

    cargaMasivaActiva = false;

    docType: any[] = [];

    usuariosession: Usuario;

    displayedColumns = [
        'type',
        'ruc',
        'businessName',
        'mtcRecord',
        'documentType',
        'documentNumber',
        'name',
        'lastName',
        'licenseNumber',
        'actionsColumn'
    ];
    dataSource = new MatTableDataSource<GreCarrier>();

    @ViewChild(MatPaginator) paginator: MatPaginator;

    popupPoint = false;
    edit = false;
    loadingActualizar = false;
    carrierModificar: GreCarrier = new GreCarrier();

    formCarrierNuevo: FormGroup;
    vld_typeNuevo: FormControl;
    vld_rucNuevo: FormControl;
    vld_businessNameNuevo: FormControl;
    vld_MTCRecordNuevo: FormControl;
    vld_documentTypeNuevo: FormControl;
    vld_documentNumberNuevo: FormControl;
    vld_nameNuevo: FormControl;
    vld_lastNameNuevo: FormControl;
    vld_licenceNumberNuevo: FormControl;

    /**
     * Set the paginator after the view init since this component will
     * be able to query its view for the initialized paginator.
     */
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }

    applyFilter(filterValue: any) {
        filterValue = filterValue.value.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }

    constructor(private receiverValidator: ValidatorService,
                private cd: ChangeDetectorRef,
                private fb: FormBuilder,
                private snackBar: MatSnackBar,
                private router: Router,
                private util: UtilConfig, private consumerService: ConsumerService) {
        this.rutaFormato = this.util.URL_WS_BACKEND + '/Carrier.xlsx';

        this.docType.push({value: this.DNI, label: 'DNI'});
        this.docType.push({value: this.CARNET_EXTRAJERIA, label: 'Carnet de extrajenria'});
        this.docType.push({value: this.PASAPORTE, label: 'Pasaporte'});
        this.docType.push({value: this.DND, label: 'DND'});

        this.usuariosession = this.util.getCurrentUser();
        this.createFormControls();
        this.createFormReceptorNuevo();

    }

    createFormControls() {
        this.vld_typeNuevo = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_rucNuevo = new FormControl({value: ''}, [Validators.nullValidator, Validators.minLength(11), Validators.maxLength(11)]);
        this.vld_businessNameNuevo = new FormControl({value: false}, [Validators.nullValidator]);
        this.vld_MTCRecordNuevo = new FormControl({value: false}, [Validators.nullValidator]);
        this.vld_documentTypeNuevo = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_documentNumberNuevo = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_nameNuevo = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_lastNameNuevo = new FormControl({value: ''}, [Validators.nullValidator]);
        this.vld_licenceNumberNuevo = new FormControl({value: ''}, [Validators.nullValidator]);

    }

    createFormReceptorNuevo() {
        this.formCarrierNuevo = this.fb.group({
            'type': this.vld_typeNuevo,
            'ruc': this.vld_rucNuevo,
            'businessName': this.vld_businessNameNuevo,
            'mtcRecord': this.vld_MTCRecordNuevo,
            'documentType': this.vld_documentTypeNuevo,
            'documentNumber': this.vld_documentNumberNuevo,
            'name': this.vld_nameNuevo,
            'lastName': this.vld_lastNameNuevo,
            'licenceNumber': this.vld_licenceNumberNuevo
        });
    }

    ngOnInit() {
        if (!this.emisor) {
            this.emisor = new Emisor();
        }
        this.dataSource.data = this.emisor.greCarrierList;
    }

    subirArchivo($event) {
        const input = $event.currentTarget;

        if (input.files && input.files[0]) {
            const reader = new FileReader();
            reader.onload = (e: FileReaderEvent) => {
                this.archivoExcel = e.target.result.split('base64,')[1];
                const param: any = {};
                param.massiveLoadFile = this.archivoExcel;
                this.cargaMasivaActiva = true;
                this.consumerService.post<any>(WebServices.URL_CARGA_MASIVA_CARRIERS, param)
                    .subscribe(result => {
                        const receptores = result['grecarriers'];
                        if (result['codigo'] === 1) {
                            if (result['mensaje'] !== 'OK') {
                                swal({
                                    title: 'Los siguientes puntos no se pudieron cargar:',
                                    text: result['mensaje'],
                                    type: 'error',
                                    showCancelButton: false,
                                    confirmButtonColor: '#3085d6',
                                    confirmButtonText: 'ok'
                                });
                            }
                            $.each(receptores, (pos, item) => {
                                this.emisor.greCarrierList.push(item);
                                this.cd.markForCheck();
                                this.cd.detectChanges();
                            });
                            this.dataSource.data = this.emisor.greCarrierList;
                            input.files = null;
                            $('#wizard-greCarriers').val('');
                        }
                        this.cargaMasivaActiva = false;
                    }, err => {
                        this.cargaMasivaActiva = false;
                    });


            };
            reader.readAsDataURL(input.files[0]);
        }
    }
    onDeleteConfirm(event) {
        let index = -1;
        let pos = 0;
        this.emisor.greCarrierList.forEach((item) => {
            if (item.id === event.id) {
                index = pos;
            }
            pos++;
        });
        if (index > -1) {
            this.emisor.greCarrierList.splice(index, 1);
            this.dataSource.data = this.emisor.greCarrierList;
        }
    }

    modificarPoint(element) {
        this.openPopupPoint();
        this.edit = true;
        this.carrierModificar = element;
    }

    openPopupPoint() {
        this.carrierModificar = new GreCarrier();
        this.edit = false;
        this.popupPoint = true;
    }

    cerrarPopup() {
        this.carrierModificar = new GreCarrier();
        this.popupPoint = false;
        this.edit = false;
    }

    handlerReceptorNuevo(event) {
        this.cerrarPopup();
        if (!event.id) {
            this.emisor.greCarrierList.push(event);
            this.dataSource.data = this.emisor.greCarrierList;
        }
    }


    agregarCarrier() {
        const body: any = {
            greCarrier: this.carrierModificar
        };

        this.loadingActualizar = true;
        this.consumerService.create(WebServices.URL_ACTUALIZAR_CARRIER, body)
            .subscribe(result => {
                this.loadingActualizar = false;
                const carrier = new GreCarrier();
                if (result['greCarrier'] != null) {
                    const item = result['greCarrier'];
                    carrier.id = item.id;
                    carrier.type = item.type;
                    carrier.ruc = item.ruc;
                    carrier.businessName = item.businessName;
                    carrier.mtcRecord = item.mtcRecord;
                    carrier.documentType = item.documentType;
                    carrier.documentNumber = item.documentNumber;
                    carrier.name = item.name;
                    carrier.lastName = item.lastName;
                    carrier.licenseNumber = item.licenseNumber;
                }
                if (!this.edit) {
                    this.emisor.greCarrierList.push(carrier);
                    this.dataSource.data = this.emisor.greCarrierList;
                }
                this.cerrarPopup();
                this.snackBar.open('Se ha agregado de forma exitosa el punto.', null, {duration: 2000});
            }, err => {
                this.loadingActualizar = false;
                this.util.abrirModalErrorParaServicios(err, 'No se pudo crear el punto', this.router);
            });
    }

    adaptarValidacion() {
        if (this.carrierModificar.documentType === '0') {
            this.tamanoIdDocNumber = '15';
            this.formCarrierNuevo.controls['documentNumber'].setValidators([Validators.required,
                Validators.maxLength(15)]);
            this.formCarrierNuevo.controls['documentNumber'].setValue('');
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator dnd_after');
        }
        if (this.carrierModificar.documentType === '1') {
            this.tamanoIdDocNumber = '8';
            this.formCarrierNuevo.controls['documentNumber']
                .setValidators([Validators.required,
                    Validators.maxLength(8)]);
            this.formCarrierNuevo.controls['documentNumber'].setValue('');
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator dni_after');
        }

        if (this.carrierModificar.documentType === '4') {
            this.tamanoIdDocNumber = '15';
            this.formCarrierNuevo.controls['documentNumber'].setValidators([Validators.required,
                Validators.maxLength(15)]);
            this.formCarrierNuevo.controls['documentNumber'].setValue('');
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator carnetExtrajenria_after');

        }
        if (this.carrierModificar.documentType === '6') {
            this.tamanoIdDocNumber = '11';
            this.formCarrierNuevo.controls['documentNumber'].setValidators([Validators.required,
                Validators.minLength(11), Validators.maxLength(11)]);
            this.formCarrierNuevo.controls['documentNumber'].setValue('');
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator ruc_after');
        }

        if (this.carrierModificar.documentType === '7') {
            this.tamanoIdDocNumber = '15';
            this.formCarrierNuevo.controls['documentNumber'].setValidators([Validators.required,
                Validators.maxLength(15)]);
            this.formCarrierNuevo.controls['documentNumber'].setValue('');
            $('.numeroDocumentoValidator').attr('class', 'col-md-4 numeroDocumentoValidator pasaporte_after');
        }
        this.cd.markForCheck();
        this.cd.detectChanges();
    }

    onPaste(event: ClipboardEvent, input) {
        const clipboardData = event.clipboardData || window['clipboardData'];
        const pastedText = clipboardData.getData('text');
        input = pastedText;
        this.formCarrierNuevo.updateValueAndValidity();
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/cmp-conf-gre-carrier/cmp-conf-gre-carrier.component.ts